import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
const TermosUso = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Termos de Uso | HabitFrog</title>
        <meta name="description" content="Leia os Termos de Uso do HabitFrog. Conheça as regras e condições para utilização da nossa plataforma de gamificação de hábitos." />
        <link rel="canonical" href="https://habitfrog.com/termos-uso" />
      </Helmet>

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <article className="max-w-3xl mx-auto prose prose-lg">
            <h1 className="text-4xl font-display font-bold text-foreground mb-8">
              Termos de Uso
            </h1>
            <p className="text-muted-foreground mb-4">Última atualização: Janeiro de 2026</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">1. Aceitação dos Termos</h2>
              <p className="text-foreground/80 mb-4">
                Ao acessar ou usar o HabitFrog, você concorda em cumprir estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não poderá acessar o serviço.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">2. Descrição do Serviço</h2>
              <p className="text-foreground/80 mb-4">
                O HabitFrog é uma plataforma de gamificação para criação e acompanhamento de hábitos. Oferecemos ferramentas para ajudar usuários a desenvolver rotinas saudáveis através de mecânicas de jogo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">3. Conta do Usuário</h2>
              <p className="text-foreground/80 mb-4">
                Você é responsável por manter a confidencialidade de sua conta e senha. Concorda em notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">4. Uso Aceitável</h2>
              <p className="text-foreground/80 mb-4">
                Você concorda em usar o HabitFrog apenas para fins legais. É proibido: usar o serviço para atividades ilegais, tentar acessar contas de outros usuários, ou interferir no funcionamento da plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">5. Propriedade Intelectual</h2>
              <p className="text-foreground/80 mb-4">
                Todo o conteúdo do HabitFrog, incluindo textos, gráficos, logos e software, é propriedade da empresa e protegido por leis de direitos autorais.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">6. Pagamentos e Reembolsos</h2>
              <p className="text-foreground/80 mb-4">
                Assinaturas são cobradas mensalmente. Você pode cancelar a qualquer momento. Reembolsos são avaliados caso a caso para os primeiros 7 dias de assinatura.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">7. Limitação de Responsabilidade</h2>
              <p className="text-foreground/80 mb-4">
                O HabitFrog é fornecido "como está". Não garantimos que o serviço será ininterrupto ou livre de erros. Não nos responsabilizamos por danos indiretos resultantes do uso da plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">8. Alterações nos Termos</h2>
              <p className="text-foreground/80 mb-4">
                Podemos modificar estes termos a qualquer momento. Alterações significativas serão comunicadas por e-mail ou notificação no aplicativo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">9. Contato</h2>
              <p className="text-foreground/80">
                Dúvidas sobre estes termos? Entre em contato: legal@habitfrog.com
              </p>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermosUso;
